module.exports = __webpack_public_path__ + "static/media/energy1.fe0a8310.jpg";